<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload,
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  mounted(){
    // window.addEventListener('unload', this.saveState);
    // window.addEventListener("load", () => {
    //   localStorage.clear();
    // });
  },
  methods: {
    // saveState () {
    //   alert(this.$store.state)
    //   localStorage.setItem('state', JSON.stringify(this.$store.state))
    // },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style lang="less">
html, body,#app{
  height: 100%;
}
</style>
